import React from "react";
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import YoutubeEmbed from "./YoutubeEmbed"

import styled from 'styled-components';

import backgroundPic from "./images/headphones.jpg";
import Footer from "./Footer"

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  title: {
    flexGrow: 1,
    textAlign: 'start',
    color:"#FFF"
  },
  appBar:{
    background:"transparent",
    elevation:0
  },
  myTabs:{
    textAlign:"end",
    padding:20
  },
  tabButns:{
    border:"transparent",
    color:"#FFF"
  },
  headerBackground:{
    background: `url(${backgroundPic}) no-repeat`,
    backgroundSize: "cover",

  },
  textOnSlideShow:{
    textAlign:"center",
    width:"80%",
    color:"#FFF",
    alignContent:"center",
    alignItems:"center",
    
  }
 
}));

const StyledButton = styled.button`
color: white;
	padding: 5px;
	border: 1px;
	background: none;
  font-size: 1em;
  margin: 5px 10px 0px;

	&:hover {
		background: none;
    color: purple;
    cursor:pointer;
	}
`;

function Videos() {
  const classes = useStyles();


  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item xs={12} className={classes.headerBackground}>
        <AppBar position="static" className={classes.appBar}>
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            K-BRIELLY MUSIC
          </Typography>
        </Toolbar>
      </AppBar>
      <div className={classes.myTabs}>
        <StyledButton
        onClick={()=>{
          window.location.href="/"
        }}
          onMouseEnter={()=>{
            console.log("color")
          }}>
          HOME
        </StyledButton>
        <StyledButton
        onClick={()=>{
          window.location.href="/stream"
        }}
        >
          STREAM
        </StyledButton>
        <StyledButton
        onClick={()=>{
          window.location.href="/music"
        }}
        >
          MUSIC
        </StyledButton>
        <StyledButton
        onClick={()=>{
          window.location.href="/videos"
        }}
        >
          VIDEOS
        </StyledButton>
        <StyledButton
        onClick={()=>{
          window.location.href="/contacts"
        }}
        >
          CONTACT
        </StyledButton>
        <StyledButton
        onClick={()=>{
          window.location.href="/about"
        }}
        >
          ABOUT
        </StyledButton>
        <StyledButton
        onClick={()=>{
          window.location.href="/"
        }}
        >
          BLOG
        </StyledButton>
      </div>
      <hr></hr>
        </Grid>
        <Grid item xs={12} style={{background:"black"}}>
          <Typography style={{color:"#FFF",textAlign:"start",padding:20}}>
            K-Brielly_Seasons Come And Go(Official Video)
          </Typography>
          <Grid item xs={12} style={{paddingBottom:20}}>
            <YoutubeEmbed embedId="fX3WMP6LRdU"/>
          </Grid>
          <Typography style={{color:"#FFF",textAlign:"start",padding:20}}>
            K-BRIELLY_KING(Official Video)
          </Typography>
          <Grid item xs={12} style={{paddingBottom:20}}>
            <YoutubeEmbed embedId="R69Yz7LTfo8"/>
          </Grid>
          <Typography style={{color:"#FFF",textAlign:"start",padding:20}}>
            K-Brielly_Gabs City(Official Audio)
          </Typography>
          <Grid item xs={12} style={{paddingBottom:20}}>
            <YoutubeEmbed embedId="blvjQkb0a6A"/>
          </Grid>
          <Typography style={{color:"#FFF",textAlign:"start",padding:20}}>
            K-Brielly_Freshman(Official Audio)
          </Typography>
          <Grid item xs={12} style={{paddingBottom:20}}>
            <YoutubeEmbed embedId="Sow0W0divZE"/>
          </Grid>
          <Typography style={{color:"#FFF",textAlign:"start",padding:20}}>
            K-BRIELLY ft. MarkWicked_Game On(Official Audio)
          </Typography>
          <Grid item xs={12} style={{paddingBottom:20}}>
            <YoutubeEmbed embedId="jrTgWyWNnV4"/>
          </Grid>
          
          <Typography style={{color:"#FFF",textAlign:"start",padding:20}}>
           Broken Soul_K-Brielly(lyric video)
          </Typography>
          <Grid item xs={12} style={{paddingBottom:20}}>
            <YoutubeEmbed embedId="6c9-oQVObJM"/>
          </Grid>

          <Typography style={{color:"#FFF",textAlign:"start",padding:20}}>
            K-Brielly_I'm Nice(Official Audio)
          </Typography>
          <Grid item xs={12} style={{paddingBottom:20}}>
            <YoutubeEmbed embedId="vYTg2aT1MWw"/>
          </Grid>
         
        <Grid item xs={12} >
          <Footer/>
        </Grid>
        </Grid>
        </Grid>
      
    </div> 
  );
}

export default Videos;
